import { v4 as uuidv4 } from 'uuid';

export function assignEditorIds (layout: any[]): any[] {
  const cloned = structuredClone(layout);
  if (cloned[0]?.children) {
    cloned[0].children.forEach((row: any) => {
      if (!row._editorId) {
        row._editorId = uuidv4();
      }
    });
  }
  return cloned;
}

export function stripEditorIds (layout: any[]): any[] {
  const cloned = structuredClone(layout);
  if (cloned[0]?.children) {
    cloned[0].children.forEach((row: any) => {
      delete row._editorId;
    });
  }
  return cloned;
}
